import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';

import { snapshot } from '@fcom/rx';
import { orderData } from '@fcom/common-booking';
import { FinnairCheckInVersion } from '@fcom/dapi/api/models';

import { MmbStage } from '../enums';
import { getCheckInBoundId } from '../store/selectors/check-in.selector';
import { StateActions } from '../store';

export const CheckInFlowGuard: CanActivateFn = (): boolean => {
  const platform = inject(PLATFORM_ID);
  const store$ = inject(Store);

  if (isPlatformServer(platform)) {
    store$.dispatch(StateActions.setStage({ stage: MmbStage.CHECK_IN_FLOW }));
    return true;
  }

  const order = snapshot(store$.pipe(orderData()));
  const boundId = snapshot(store$.pipe(getCheckInBoundId()));
  if (
    order?.eligibilities?.checkIn?.find((eligibility) => eligibility.id === boundId)?.version ===
    FinnairCheckInVersion.NEXTGEN
  ) {
    store$.dispatch(StateActions.setStage({ stage: MmbStage.CHECK_IN_FLOW }));
    return true;
  }
  store$.dispatch(StateActions.setStage({ stage: MmbStage.LOGIN }));
  return false;
};
